export const SAVE_SHAREDMAILBOXES = 'SAVE_SHAREDMAILBOXES';
export const FETCH_SHAREDMAILBOXES = 'FETCH_SHAREDMAILBOXES';
export const SHAREDMAILBOX_FETCH_FAILED = 'SHAREDMAILBOX_FETCH_FAILED';
export const DELETE_SM_INIT = 'DELETE_SM_INIT';
export const DELETE_SM_FAILED = 'DELETE_SM_FAILED';
export const DELETE_SM_DONE = 'DELETE_SM_DONE';
export const DELETE_CHAT_INBOX_INIT = 'DELETE_CHAT_INBOX_INIT';
export const DELETE_CHAT_INBOX_DONE = 'DELETE_CHAT_INBOX_DONE';
export const DELETE_CHAT_INBOX_FAILED = 'DELETE_CHAT_INBOX_FAILED';
export const DELETE_WHATSAPP_INBOX_INIT = 'DELETE_WHATSAPP_INBOX_INIT';
export const DELETE_WHATSAPP_INBOX_DONE = 'DELETE_WHATSAPP_INBOX_DONE';
export const DELETE_WHATSAPP_INBOX_FAILED = 'DELETE_WHATSAPP_INBOX_FAILED';
export const DELETE_VOICE_INBOX_INIT = 'DELETE_VOICE_INBOX_INIT';
export const DELETE_VOICE_INBOX_DONE = 'DELETE_VOICE_INBOX_DONE';
export const DELETE_VOICE_INBOX_FAILED = 'DELETE_VOICE_INBOX_FAILED';
